export const FORM_TYPES = {
	CUSTOMER: 'customer',
	VENDOR: 'vendor',
	ADMINISTRATOR: 'administrator'
};
export const GTM_FORM_TYPES = {
	customer: 'Vevő',
	vendor: 'Eladó',
	administrator: 'Ügyintéző'
};

export const BUILDING_TYPES = {
	TARSAS_DUMMY: 'LAKAS_DUMMY',
	CSALAD_DUMMY: 'CSALAD_DUMMY',
	SORHAZ_DUMMY: 'SORHAZ_DUMMY'
};
export const LOADING_STATES = {
	IDLE: 'IDLE',
	IN_PROGRESS: 'IN_PROGRESS'
};
export const NAME_REGEXP = "^[\\p{L}\\s\\.\\-\\']*$";
export const MOBILE_PHONE_REGEXP = '^(70|20|30|31|50)\\s\\d{3}\\s\\d{4}$';
